import store from '@/assets/common/store/state.js';

const getters = {
    getNowSystemTime: (state) => state.nowSystemTime
};

for (let key in store) {
    getters[`getter${key}`] = function (state) {
        return state[key];
    }
}

export default getters;